module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/3@2x_2f8ee67b8798d1ae161cfbe4125dfd06.png";